import {Pipe, PipeTransform} from '@angular/core';
import {Util} from "../../app/util";

/**
 * Generated class for the CurrencyPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
    name: 'currency',
})
export class CurrencyPipe implements PipeTransform {

    constructor(public util: Util) {


    }

    transform(value: number, ...args) { // ...args -> quando aceita infinitos argumentos?

        //todo: vamos usar assim?? ou dentro da dinheiro() vamos colocar assim?
        //return new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);
        return this.util.currency(value);

    }

}



// WEBPACK FOOTER //
// ./src/pipes/currency/currency.ts